<mat-slide-toggle
	[formControl]="activeControl"
	size="large"
	[attr.color]="initStream ? 'green' : 'yellow'"
	class="slds-m-left--large eff-slide-toggle"
>
	<span class="ds-h-colors-txt--white">AI Assistant</span>
</mat-slide-toggle>
